import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { yesNoArray, select, jobRoleLists, countryLists, religionLists, ageGroupLists, ethnicLists, illnessePlaceHolderLists } from '../../_models/staticArray';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from '../../services/user-document.service';
import { MatHorizontalStepper, MatStepper } from '@angular/material';
import * as moment from 'moment';
import * as _ from 'lodash';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { FileQueueObject } from 'src/app/services/file-uploader.service';
declare var what3words: any;



@Component({
  selector: 'sponsor-pack',
  templateUrl: './sponsor-pack.component.html',
  styleUrls: ['./sponsor-pack.component.scss']
})
export class SponsorPackComponent implements OnInit {
  @Input('formData') userFormData
  @Output() isTopToApp: EventEmitter<any> = new EventEmitter();
  @Output() formClose: EventEmitter<any> = new EventEmitter();
  @Output() userAction: EventEmitter<any> = new EventEmitter();
  // @ViewChild('stepper', { static: true }) public myStepper: MatStepper;
  @ViewChild(MatHorizontalStepper, { static: false }) stepper: MatHorizontalStepper;

  sectionOneForm: FormGroup;
  personlDetailsForm: FormGroup;
  workEligibilityForm: FormGroup;
  opportunitiesForm: FormGroup;
  railPPEForm: FormGroup;
  kinDetailsForms: FormGroup;
  illnessForm: FormGroup;
  workIllnessForm: FormGroup;
  otherSafetyReqForm: FormGroup;
  otherQuestionsForm: FormGroup;
  medicationForm: FormGroup;
  medicalEyeStandardForm: FormGroup;
  nightWorkerForm: FormGroup;
  workingTimeForm: FormGroup;
  workingHourDisclaimerForm: FormGroup;
  sponserShipContractForm: FormGroup;
  referencesForm: FormGroup;
  confirmationForm: FormGroup;
  yesNoArray = yesNoArray
  showWorkIllnessDetail = false
  isErrorShow = false
  showMessage = false
  _isNotDisplay = false
  currentFormData
  loading = true
  currentDate = moment().format("MM/DD/YYYY")
  userData
  _isComplete = false
  isMapEdit = false
  latitude: number;
  longitude: number;
  address
  _isMapDisable = true
  what3words = {}
  select = select
  jobRoleList = jobRoleLists
  url1: any;
  countryList = countryLists
  fileList: any
  religionList = religionLists
  ageGroupList = ageGroupLists
  ethnicList = ethnicLists
  illnessePlaceHolderList = illnessePlaceHolderLists
  _isFinalStep = false
  profilePhoto
  constructor(
    public _formBuilder: FormBuilder,
    public _cd: ChangeDetectorRef,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService
  ) { }

  ngOnInit(): void {
    this.createForm()
    setTimeout(() => {
      this.loading = false
    }, 4000);
    console.log("CURRENT DATE DATA", this.currentDate)
  }


  ngOnChanges(changes: SimpleChanges): void {

    console.log("FORM DATA CHANGES ", changes.userFormData.currentValue);
    if (changes.userFormData && changes.userFormData.currentValue) {
      this.currentFormData = changes.userFormData.currentValue
      this.userData = this.currentFormData.details.personlDetails
      if (this.currentFormData.details.sectionOneDetails && this.currentFormData.details.sectionOneDetails.profilePhoto) {
        this.url1 = this.currentFormData.details.sectionOneDetails.profilePhoto.path
      }
      this.longitude = this.userData && this.userData.coordinates && this.userData.coordinates.length ? this.userData.coordinates[0] : null
      this.latitude = this.userData && this.userData.coordinates && this.userData.coordinates.length ? this.userData.coordinates[1] : null
      this._isNotDisplay = true
      this._isComplete = true
      this._isFinalStep = true
      this._isMapDisable = false
      this.createForm(this.currentFormData.details)
    } else {
      this._isComplete = false
      this._isMapDisable = true
      
    }

  }


  // FORM GROUP

  createForm(data?) {
    this.createSecotiononeForm((data && data.sectionOneDetails) ? data.sectionOneDetails : '')
    this.createPersonlDetailsForm((data && data.personlDetails) ? data.personlDetails : '')
    this.createWorkEligibilityForm((data && data.workEligibilityDetails) ? data.workEligibilityDetails : '')
    this.createOpportunitiesForm((data && data.opportunitiesDetails) ? data.opportunitiesDetails : '')
    this.createRailPPEForm((data && data.railPPEDetails) ? data.railPPEDetails : '')
    this.createkinDetailsForm((data && data.kinDetails) ? data.kinDetails : '')
    this.createIllnessFormV2((data && data.illness) ? data.illness : '')
    this.createWorkIllnessForm((data && data.workIllness) ? data.workIllness : '')
    this.createOtherSafetyReqForm((data && data.otherSafetyReq) ? data.otherSafetyReq : '')
    this.createOtherQuestionsForm((data && data.otherQuestions) ? data.otherQuestions : '')
    this.createMedicationForm((data && data.medicationDetails) ? data.medicationDetails : '')
    this.createMedicalEyeStandardForm((data && data.medicalEyeStandard) ? data.medicalEyeStandard : '')
    this.createNightWorkerForm((data && data.nightWorker) ? data.nightWorker : '')
    this.createWorkingTimeForm((data && data.workingTime) ? data.workingTime : '')
    this.createWorkingHourDisclaimerForm((data && data.workingHourDisclaimer) ? data.workingHourDisclaimer : '')
    this.createSponserShipContractForm((data && data.sponserShipContract) ? data.sponserShipContract : '')
    this.createReferencesForm((data && data.referencesDetails) ? data.referencesDetails : '')
    this.createConfirmationForm((data && data.confirmationDetails) ? data.confirmationDetails : '')
  }

  createSecotiononeForm(sectionOneData?) {
    this.sectionOneForm = this._formBuilder.group({
      sponsorStatus: new FormControl((sectionOneData && sectionOneData.sponsorStatus) ? sectionOneData.sponsorStatus : '', Validators.required),
      sponsorJobRole: new FormControl((sectionOneData && sectionOneData.sponsorJobRole) ? sectionOneData.sponsorJobRole : ''),
      profilePhoto: new FormControl((sectionOneData && sectionOneData.profilePhoto) ? sectionOneData.profilePhoto : '')
    })
  }

  createPersonlDetailsForm(personlData?) {
    this.personlDetailsForm = this._formBuilder.group({
      fullName: new FormControl((personlData && personlData.fullName) ? personlData.fullName : '', Validators.required),
      dobDate: new FormControl((personlData && personlData.dobDate) ? personlData.dobDate : '', Validators.required),
      insuranceNumber: new FormControl((personlData && personlData.insuranceNumber) ? personlData.insuranceNumber : '', Validators.required),
      // address: new FormControl((personlData && personlData.address) ? personlData.address : '', Validators.required),
      telephoneNumber: new FormControl((personlData && personlData.telephoneNumber) ? personlData.telephoneNumber : '', Validators.required),
      sentinelNumber: new FormControl((personlData && personlData.sentinelNumber) ? personlData.sentinelNumber : ''),
      email: new FormControl((personlData && personlData.email) ? personlData.email : '', Validators.email),
      _isLicence: new FormControl((personlData && personlData._isLicence) ? personlData._isLicence : '', Validators.required),
      _isVehicleAccess: new FormControl((personlData && personlData._isVehicleAccess) ? personlData._isVehicleAccess : '', Validators.required),
      userAddress: new FormControl(((personlData && personlData.userAddress)) ? personlData.userAddress : ''),
      coordinates: new FormControl((personlData && personlData.coordinates) ? personlData.coordinates : []),
      address: this._formBuilder.array(this.addresList((personlData && personlData.address) ? personlData.address : [])),
      // address: this.formBuilder.array(this.addresList((data && data.jobLocation) ? data.jobLocation._id.address : [])),
      what3words: new FormControl((personlData && personlData.what3words) ? personlData.what3words : ''),
    })
  }


  createWorkEligibilityForm(eligibilityData?) {
    this.workEligibilityForm = this._formBuilder.group({
      que1: new FormControl((eligibilityData && eligibilityData.que1) ? eligibilityData.que1 : '', Validators.required),
      que1Yes: new FormControl((eligibilityData && eligibilityData.que1Yes) ? eligibilityData.que1Yes : ''),
      que1No: new FormControl((eligibilityData && eligibilityData.que1No) ? eligibilityData.que1No : ''),
      // que2: new FormControl((eligibilityData && eligibilityData.que2) ? eligibilityData.que2 : '', Validators.required),
      documents: new FormControl((eligibilityData && eligibilityData.documents) ? eligibilityData.documents : []),
      // que2No: new FormControl((eligibilityData && eligibilityData.que2No) ? eligibilityData.que2No : ''),
      // que2OtherNo: new FormControl((eligibilityData && eligibilityData.que2OtherNo) ? eligibilityData.que2OtherNo : ''),
      notApplicable: new FormControl((eligibilityData && eligibilityData.notApplicable) ? eligibilityData.notApplicable : false),
      que3: new FormControl((eligibilityData && eligibilityData.que3) ? eligibilityData.que3 : ''),
      que4: new FormControl((eligibilityData && eligibilityData.que4) ? eligibilityData.que4 : ''),
      que5: new FormControl((eligibilityData && eligibilityData.que5) ? eligibilityData.que5 : ''),
      queComment: new FormControl((eligibilityData && eligibilityData.queComment) ? eligibilityData.queComment : ''),
    })
  }

  createOpportunitiesForm(opportunitiesData?) {
    this.opportunitiesForm = this._formBuilder.group({
      que1: new FormControl((opportunitiesData && opportunitiesData.que1) ? opportunitiesData.que1 : '', Validators.required),
      que2: new FormControl((opportunitiesData && opportunitiesData.que2) ? opportunitiesData.que2 : '', Validators.required),
      // que2Other: new FormControl((opportunitiesData && opportunitiesData.que2Other) ? opportunitiesData.que2Other : ''),
      que3: new FormControl((opportunitiesData && opportunitiesData.que3) ? opportunitiesData.que3 : '', Validators.required),
      que4: new FormControl((opportunitiesData && opportunitiesData.que4) ? opportunitiesData.que4 : '', Validators.required),
      // que4Other: new FormControl((opportunitiesData && opportunitiesData.que4Other) ? opportunitiesData.que4Other : ''),
    })
  }


  createRailPPEForm(ppeFormData?) {
    this.railPPEForm = this._formBuilder.group({
      ppeQue1: new FormControl((ppeFormData && ppeFormData.ppeQue1) ? ppeFormData.ppeQue1 : '', Validators.required),
      ppeQue2: new FormControl((ppeFormData && ppeFormData.ppeQue2) ? ppeFormData.ppeQue2 : '', Validators.required),
      ppeQue3: new FormControl((ppeFormData && ppeFormData.ppeQue3) ? ppeFormData.ppeQue3 : '', Validators.required),
      ppeQue4: new FormControl((ppeFormData && ppeFormData.ppeQue4) ? ppeFormData.ppeQue4 : '', Validators.required),
      ppeQue5: new FormControl((ppeFormData && ppeFormData.ppeQue5) ? ppeFormData.ppeQue5 : '', Validators.required),
      ppeQue6: new FormControl((ppeFormData && ppeFormData.ppeQue6) ? ppeFormData.ppeQue6 : '', Validators.required),
      ppeQue7: new FormControl((ppeFormData && ppeFormData.ppeQue7) ? ppeFormData.ppeQue7 : '', Validators.required),
      ppeQue8: new FormControl((ppeFormData && ppeFormData.ppeQue8) ? ppeFormData.ppeQue8 : '', Validators.required),
      ppeQue9: new FormControl((ppeFormData && ppeFormData.ppeQue9) ? ppeFormData.ppeQue9 : '', Validators.required),
      ppeDate: new FormControl((ppeFormData && ppeFormData.ppeDate) ? ppeFormData.ppeDate : this.currentDate, Validators.required),
      ppeName: new FormControl((ppeFormData && ppeFormData.ppeName) ? ppeFormData.ppeName : '', Validators.required),
      ppeSign: new FormControl((ppeFormData && ppeFormData.ppeSign) ? ppeFormData.ppeSign : '', Validators.required),

    })
  }

  getAddressList() {
    return this.personlDetailsForm.get('address') as FormArray;
  }

  // Generate formarray for address list
  addresList(address) {
    console.log("ADDDRESS OF USER", typeof address);
    if (typeof address !== 'string' && address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl({ value: (singleLocation && singleLocation.title) ? singleLocation.title : '', disabled: true }),
        }))
      })
      return locationArray;
    } else {
      return [this._formBuilder.group({
        title: new FormControl({ value: '', disabled: true })
      })]
    }
  }

  createkinDetailsForm(kinDetails) {
    this.kinDetailsForms = this._formBuilder.group({
      name: new FormControl((kinDetails && kinDetails.name) ? kinDetails.name : '', Validators.required),
      relationship: new FormControl((kinDetails && kinDetails.relationship) ? kinDetails.relationship : ''),
      address: new FormControl((kinDetails && kinDetails.address) ? kinDetails.address : '', Validators.required),
      contactNumber: new FormControl((kinDetails && kinDetails.contactNumber) ? kinDetails.contactNumber : '', Validators.required),
      secondaryContactNumber: new FormControl((kinDetails && kinDetails.secondaryContactNumber) ? kinDetails.secondaryContactNumber : ''),
      kinEmail: new FormControl((kinDetails && kinDetails.kinEmail) ? kinDetails.kinEmail : '', Validators.email),
    })
  }



  createIllnessFormV2(illnessDetails?) {
    this.illnessForm = this._formBuilder.group({
      selectAllNo: new FormControl((illnessDetails && illnessDetails.selectAllNo) ? illnessDetails.selectAllNo : false),
      illnesses: this._formBuilder.array(this.multipleIllnesses((illnessDetails && illnessDetails.illnesses) ? illnessDetails.illnesses : [])) // FormArray to store illnesses
    });
    console.log("THIS IS THE NEW FORM CREATED", this.illnessForm)
  }


  get getIllnessesList(): FormArray { return this.illnessForm.get('illnesses') as FormArray; }

  multipleIllnesses(illnessesDetails?) {
    let illnessArray = []
    if (illnessesDetails && illnessesDetails.length) {
      for (let i = 0; i < illnessesDetails.length; i++) {
        illnessArray.push(this.updateIllnessGroup(i, illnessesDetails[i]))
      }
    } else {
      for (let i = 1; i <= this.illnessePlaceHolderList.length; i++) {
        console.log("AFTER UPDATE", illnessesDetails)
        illnessArray.push(this.createIllnessGroup(i, illnessesDetails));
      }
    }
    console.log("WHAT IS THE VALUE OF CURRENT ARRAY", illnessArray)
    return illnessArray
  }


  createIllnessGroup(index: number, illnessesDetails): FormGroup {
    // console.log("WHAT IS DATA", illnessesDetails[index - 1][`illness${index - 1}`])
    return this._formBuilder.group({
      [`label${index}`]: new FormControl(this.illnessePlaceHolderList[index - 1]),
      [`illness${index}`]: new FormControl('', Validators.required),
      [`medication${index}`]: new FormControl(''),
      [`dose${index}`]: new FormControl(''),
      [`frequency${index}`]: new FormControl(''),
      [`prescribed${index}`]: new FormControl('')
    });
  }

  updateIllnessGroup(index, illnessesDetails?): FormGroup {
    console.log("DATA OF++++++++++++", illnessesDetails, index, illnessesDetails[`label${index + 1}`], illnessesDetails[`label${index}`])
    return this._formBuilder.group({
      [`label${index + 1}`]: new FormControl(illnessesDetails[`label${index + 1}`]),
      [`illness${index + 1}`]: new FormControl(illnessesDetails[`illness${index + 1}`]),
      [`medication${index + 1}`]: new FormControl(illnessesDetails[`medication${index + 1}`]),
      [`dose${index + 1}`]: new FormControl(illnessesDetails[`dose${index + 1}`]),
      [`frequency${index + 1}`]: new FormControl(illnessesDetails[`frequency${index + 1}`]),
      [`prescribed${index + 1}`]: new FormControl(illnessesDetails[`prescribed${index + 1}`])
    })
  }


  // createIllnessForm(illnessDetails) {
  //   this.illnessForm = this._formBuilder.group({
  //     selectAllNo: new FormControl((illnessDetails && illnessDetails.selectAllNo) ? illnessDetails.selectAllNo : false),
  //     illness1: new FormControl((illnessDetails && illnessDetails.illness1) ? illnessDetails.illness1 : '', Validators.required),
  //     medication1: new FormControl((illnessDetails && illnessDetails.medication1) ? illnessDetails.medication1 : ''),
  //     dose1: new FormControl((illnessDetails && illnessDetails.dose1) ? illnessDetails.dose1 : ''),
  //     frequency1: new FormControl((illnessDetails && illnessDetails.frequency1) ? illnessDetails.frequency1 : ''),
  //     prescribed1: new FormControl((illnessDetails && illnessDetails.prescribed1) ? illnessDetails.prescribed1 : ''),
  //     illness2: new FormControl((illnessDetails && illnessDetails.illness2) ? illnessDetails.illness2 : '', Validators.required),
  //     medication2: new FormControl((illnessDetails && illnessDetails.medication2) ? illnessDetails.medication2 : ''),
  //     dose2: new FormControl((illnessDetails && illnessDetails.dose2) ? illnessDetails.dose2 : ''),
  //     frequency2: new FormControl((illnessDetails && illnessDetails.frequency2) ? illnessDetails.frequency2 : ''),
  //     prescribed2: new FormControl((illnessDetails && illnessDetails.prescribed2) ? illnessDetails.prescribed2 : ''),
  //     illness3: new FormControl((illnessDetails && illnessDetails.illness3) ? illnessDetails.illness3 : '', Validators.required),
  //     medication3: new FormControl((illnessDetails && illnessDetails.medication3) ? illnessDetails.medication3 : ''),
  //     dose3: new FormControl((illnessDetails && illnessDetails.dose3) ? illnessDetails.dose3 : ''),
  //     frequency3: new FormControl((illnessDetails && illnessDetails.frequency3) ? illnessDetails.frequency3 : ''),
  //     prescribed3: new FormControl((illnessDetails && illnessDetails.prescribed3) ? illnessDetails.prescribed3 : ''),
  //     illness4: new FormControl((illnessDetails && illnessDetails.illness4) ? illnessDetails.illness4 : '', Validators.required),
  //     medication4: new FormControl((illnessDetails && illnessDetails.medication4) ? illnessDetails.medication4 : ''),
  //     dose4: new FormControl((illnessDetails && illnessDetails.dose4) ? illnessDetails.dose4 : ''),
  //     frequency4: new FormControl((illnessDetails && illnessDetails.frequency4) ? illnessDetails.frequency4 : ''),
  //     prescribed4: new FormControl((illnessDetails && illnessDetails.prescribed4) ? illnessDetails.prescribed4 : ''),
  //     illness5: new FormControl((illnessDetails && illnessDetails.illness5) ? illnessDetails.illness5 : '', Validators.required),
  //     medication5: new FormControl((illnessDetails && illnessDetails.medication5) ? illnessDetails.medication5 : ''),
  //     dose5: new FormControl((illnessDetails && illnessDetails.dose5) ? illnessDetails.dose5 : ''),
  //     frequency5: new FormControl((illnessDetails && illnessDetails.frequency5) ? illnessDetails.frequency5 : ''),
  //     prescribed5: new FormControl((illnessDetails && illnessDetails.prescribed5) ? illnessDetails.prescribed5 : ''),
  //     illness6: new FormControl((illnessDetails && illnessDetails.illness6) ? illnessDetails.illness6 : '', Validators.required),
  //     medication6: new FormControl((illnessDetails && illnessDetails.medication6) ? illnessDetails.medication6 : ''),
  //     dose6: new FormControl((illnessDetails && illnessDetails.dose6) ? illnessDetails.dose6 : ''),
  //     frequency6: new FormControl((illnessDetails && illnessDetails.frequency6) ? illnessDetails.frequency6 : ''),
  //     prescribed6: new FormControl((illnessDetails && illnessDetails.prescribed6) ? illnessDetails.prescribed6 : ''),
  //     illness7: new FormControl((illnessDetails && illnessDetails.illness7) ? illnessDetails.illness7 : '', Validators.required),
  //     medication7: new FormControl((illnessDetails && illnessDetails.medication7) ? illnessDetails.medication7 : ''),
  //     dose7: new FormControl((illnessDetails && illnessDetails.dose7) ? illnessDetails.dose7 : ''),
  //     frequency7: new FormControl((illnessDetails && illnessDetails.frequency7) ? illnessDetails.frequency7 : ''),
  //     prescribed7: new FormControl((illnessDetails && illnessDetails.prescribed7) ? illnessDetails.prescribed7 : ''),
  //     illness8: new FormControl((illnessDetails && illnessDetails.illness8) ? illnessDetails.illness8 : '', Validators.required),
  //     medication8: new FormControl((illnessDetails && illnessDetails.medication8) ? illnessDetails.medication8 : ''),
  //     dose8: new FormControl((illnessDetails && illnessDetails.dose8) ? illnessDetails.dose8 : ''),
  //     frequency8: new FormControl((illnessDetails && illnessDetails.frequency8) ? illnessDetails.frequency8 : ''),
  //     prescribed8: new FormControl((illnessDetails && illnessDetails.prescribed8) ? illnessDetails.prescribed8 : ''),
  //     illness9: new FormControl((illnessDetails && illnessDetails.illness9) ? illnessDetails.illness9 : '', Validators.required),
  //     medication9: new FormControl((illnessDetails && illnessDetails.medication9) ? illnessDetails.medication9 : ''),
  //     dose9: new FormControl((illnessDetails && illnessDetails.dose9) ? illnessDetails.dose9 : ''),
  //     frequency9: new FormControl((illnessDetails && illnessDetails.frequency9) ? illnessDetails.frequency9 : ''),
  //     prescribed9: new FormControl((illnessDetails && illnessDetails.prescribed9) ? illnessDetails.prescribed9 : ''),
  //     illness10: new FormControl((illnessDetails && illnessDetails.illness10) ? illnessDetails.illness10 : '', Validators.required),
  //     medication10: new FormControl((illnessDetails && illnessDetails.medication10) ? illnessDetails.medication10 : ''),
  //     dose10: new FormControl((illnessDetails && illnessDetails.dose10) ? illnessDetails.dose10 : ''),
  //     frequency10: new FormControl((illnessDetails && illnessDetails.frequency10) ? illnessDetails.frequency10 : ''),
  //     prescribed10: new FormControl((illnessDetails && illnessDetails.prescribed10) ? illnessDetails.prescribed10 : ''),
  //     illness11: new FormControl((illnessDetails && illnessDetails.illness11) ? illnessDetails.illness11 : '', Validators.required),
  //     medication11: new FormControl((illnessDetails && illnessDetails.medication11) ? illnessDetails.medication11 : ''),
  //     dose11: new FormControl((illnessDetails && illnessDetails.dose11) ? illnessDetails.dose11 : ''),
  //     frequency11: new FormControl((illnessDetails && illnessDetails.frequency11) ? illnessDetails.frequency11 : ''),
  //     prescribed11: new FormControl((illnessDetails && illnessDetails.prescribed11) ? illnessDetails.prescribed11 : ''),
  //     illness12: new FormControl((illnessDetails && illnessDetails.illness12) ? illnessDetails.illness12 : '', Validators.required),
  //     medication12: new FormControl((illnessDetails && illnessDetails.medication12) ? illnessDetails.medication12 : ''),
  //     dose12: new FormControl((illnessDetails && illnessDetails.dose12) ? illnessDetails.dose12 : ''),
  //     frequency12: new FormControl((illnessDetails && illnessDetails.frequency12) ? illnessDetails.frequency12 : ''),
  //     prescribed12: new FormControl((illnessDetails && illnessDetails.prescribed12) ? illnessDetails.prescribed12 : ''),
  //     illness13: new FormControl((illnessDetails && illnessDetails.illness13) ? illnessDetails.illness13 : '', Validators.required),
  //     medication13: new FormControl((illnessDetails && illnessDetails.medication13) ? illnessDetails.medication13 : ''),
  //     dose13: new FormControl((illnessDetails && illnessDetails.dose13) ? illnessDetails.dose13 : ''),
  //     frequency13: new FormControl((illnessDetails && illnessDetails.frequency13) ? illnessDetails.frequency13 : ''),
  //     prescribed13: new FormControl((illnessDetails && illnessDetails.prescribed13) ? illnessDetails.prescribed13 : ''),
  //     illness14: new FormControl((illnessDetails && illnessDetails.illness14) ? illnessDetails.illness14 : '', Validators.required),
  //     medication14: new FormControl((illnessDetails && illnessDetails.medication14) ? illnessDetails.medication14 : ''),
  //     dose14: new FormControl((illnessDetails && illnessDetails.dose14) ? illnessDetails.dose14 : ''),
  //     frequency14: new FormControl((illnessDetails && illnessDetails.frequency14) ? illnessDetails.frequency14 : ''),
  //     prescribed14: new FormControl((illnessDetails && illnessDetails.prescribed14) ? illnessDetails.prescribed14 : ''),
  //     illness15: new FormControl((illnessDetails && illnessDetails.illness15) ? illnessDetails.illness15 : '', Validators.required),
  //     medication15: new FormControl((illnessDetails && illnessDetails.medication15) ? illnessDetails.medication15 : ''),
  //     dose15: new FormControl((illnessDetails && illnessDetails.dose15) ? illnessDetails.dose15 : ''),
  //     frequency15: new FormControl((illnessDetails && illnessDetails.frequency15) ? illnessDetails.frequency15 : ''),
  //     prescribed15: new FormControl((illnessDetails && illnessDetails.prescribed15) ? illnessDetails.prescribed15 : ''),
  //     illness16: new FormControl((illnessDetails && illnessDetails.illness16) ? illnessDetails.illness16 : '', Validators.required),
  //     medication16: new FormControl((illnessDetails && illnessDetails.medication16) ? illnessDetails.medication16 : ''),
  //     dose16: new FormControl((illnessDetails && illnessDetails.dose16) ? illnessDetails.dose16 : ''),
  //     frequency16: new FormControl((illnessDetails && illnessDetails.frequency16) ? illnessDetails.frequency16 : ''),
  //     prescribed16: new FormControl((illnessDetails && illnessDetails.prescribed16) ? illnessDetails.prescribed16 : ''),
  //     illness17: new FormControl((illnessDetails && illnessDetails.illness17) ? illnessDetails.illness17 : '', Validators.required),
  //     medication17: new FormControl((illnessDetails && illnessDetails.medication17) ? illnessDetails.medication17 : ''),
  //     dose17: new FormControl((illnessDetails && illnessDetails.dose17) ? illnessDetails.dose17 : ''),
  //     frequency17: new FormControl((illnessDetails && illnessDetails.frequency17) ? illnessDetails.frequency17 : ''),
  //     prescribed17: new FormControl((illnessDetails && illnessDetails.prescribed17) ? illnessDetails.prescribed17 : ''),
  //     illness18: new FormControl((illnessDetails && illnessDetails.illness18) ? illnessDetails.illness18 : '', Validators.required),
  //     medication18: new FormControl((illnessDetails && illnessDetails.medication18) ? illnessDetails.medication18 : ''),
  //     dose18: new FormControl((illnessDetails && illnessDetails.dose18) ? illnessDetails.dose18 : ''),
  //     frequency18: new FormControl((illnessDetails && illnessDetails.frequency18) ? illnessDetails.frequency18 : ''),
  //     prescribed18: new FormControl((illnessDetails && illnessDetails.prescribed18) ? illnessDetails.prescribed18 : ''),
  //     illness19: new FormControl((illnessDetails && illnessDetails.illness19) ? illnessDetails.illness19 : '', Validators.required),
  //     medication19: new FormControl((illnessDetails && illnessDetails.medication19) ? illnessDetails.medication19 : ''),
  //     dose19: new FormControl((illnessDetails && illnessDetails.dose19) ? illnessDetails.dose19 : ''),
  //     frequency19: new FormControl((illnessDetails && illnessDetails.frequency19) ? illnessDetails.frequency19 : ''),
  //     prescribed19: new FormControl((illnessDetails && illnessDetails.prescribed19) ? illnessDetails.prescribed19 : ''),
  //     illness20: new FormControl((illnessDetails && illnessDetails.illness20) ? illnessDetails.illness20 : '', Validators.required),
  //     medication20: new FormControl((illnessDetails && illnessDetails.medication20) ? illnessDetails.medication20 : ''),
  //     dose20: new FormControl((illnessDetails && illnessDetails.dose20) ? illnessDetails.dose20 : ''),
  //     frequency20: new FormControl((illnessDetails && illnessDetails.frequency20) ? illnessDetails.frequency20 : ''),
  //     prescribed20: new FormControl((illnessDetails && illnessDetails.prescribed20) ? illnessDetails.prescribed20 : ''),
  //     illness21: new FormControl((illnessDetails && illnessDetails.illness21) ? illnessDetails.illness21 : '', Validators.required),
  //     medication21: new FormControl((illnessDetails && illnessDetails.medication21) ? illnessDetails.medication21 : ''),
  //     dose21: new FormControl((illnessDetails && illnessDetails.dose21) ? illnessDetails.dose21 : ''),
  //     frequency21: new FormControl((illnessDetails && illnessDetails.frequency21) ? illnessDetails.frequency21 : ''),
  //     prescribed21: new FormControl((illnessDetails && illnessDetails.prescribed21) ? illnessDetails.prescribed21 : ''),
  //     illness22: new FormControl((illnessDetails && illnessDetails.illness22) ? illnessDetails.illness22 : '', Validators.required),
  //     medication22: new FormControl((illnessDetails && illnessDetails.medication22) ? illnessDetails.medication22 : ''),
  //     dose22: new FormControl((illnessDetails && illnessDetails.dose22) ? illnessDetails.dose22 : ''),
  //     frequency22: new FormControl((illnessDetails && illnessDetails.frequency22) ? illnessDetails.frequency22 : ''),
  //     prescribed22: new FormControl((illnessDetails && illnessDetails.prescribed22) ? illnessDetails.prescribed22 : ''),
  //     illness23: new FormControl((illnessDetails && illnessDetails.illness23) ? illnessDetails.illness23 : '', Validators.required),
  //     medication23: new FormControl((illnessDetails && illnessDetails.medication23) ? illnessDetails.medication23 : ''),
  //     dose23: new FormControl((illnessDetails && illnessDetails.dose23) ? illnessDetails.dose23 : ''),
  //     frequency23: new FormControl((illnessDetails && illnessDetails.frequency23) ? illnessDetails.frequency23 : ''),
  //     prescribed23: new FormControl((illnessDetails && illnessDetails.prescribed23) ? illnessDetails.prescribed23 : ''),
  //     illness24: new FormControl((illnessDetails && illnessDetails.illness24) ? illnessDetails.illness24 : '', Validators.required),
  //     medication24: new FormControl((illnessDetails && illnessDetails.medication24) ? illnessDetails.medication24 : ''),
  //     dose24: new FormControl((illnessDetails && illnessDetails.dose24) ? illnessDetails.dose24 : ''),
  //     frequency24: new FormControl((illnessDetails && illnessDetails.frequency24) ? illnessDetails.frequency24 : ''),
  //     prescribed24: new FormControl((illnessDetails && illnessDetails.prescribed24) ? illnessDetails.prescribed24 : ''),
  //     illness25: new FormControl((illnessDetails && illnessDetails.illness25) ? illnessDetails.illness25 : '', Validators.required),
  //     medication25: new FormControl((illnessDetails && illnessDetails.medication25) ? illnessDetails.medication25 : ''),
  //     dose25: new FormControl((illnessDetails && illnessDetails.dose25) ? illnessDetails.dose25 : ''),
  //     frequency25: new FormControl((illnessDetails && illnessDetails.frequency25) ? illnessDetails.frequency25 : ''),
  //     prescribed25: new FormControl((illnessDetails && illnessDetails.prescribed25) ? illnessDetails.prescribed25 : ''),
  //     illness26: new FormControl((illnessDetails && illnessDetails.illness26) ? illnessDetails.illness26 : '', Validators.required),
  //     medication26: new FormControl((illnessDetails && illnessDetails.medication26) ? illnessDetails.medication26 : ''),
  //     dose26: new FormControl((illnessDetails && illnessDetails.dose26) ? illnessDetails.dose26 : ''),
  //     frequency26: new FormControl((illnessDetails && illnessDetails.frequency26) ? illnessDetails.frequency26 : ''),
  //     prescribed26: new FormControl((illnessDetails && illnessDetails.prescribed26) ? illnessDetails.prescribed26 : ''),
  //     illness27: new FormControl((illnessDetails && illnessDetails.illness27) ? illnessDetails.illness27 : '', Validators.required),
  //     medication27: new FormControl((illnessDetails && illnessDetails.medication27) ? illnessDetails.medication27 : ''),
  //     dose27: new FormControl((illnessDetails && illnessDetails.dose27) ? illnessDetails.dose27 : ''),
  //     frequency27: new FormControl((illnessDetails && illnessDetails.frequency27) ? illnessDetails.frequency27 : ''),
  //     prescribed27: new FormControl((illnessDetails && illnessDetails.prescribed27) ? illnessDetails.prescribed27 : ''),
  //     illness28: new FormControl((illnessDetails && illnessDetails.illness28) ? illnessDetails.illness28 : '', Validators.required),
  //     medication28: new FormControl((illnessDetails && illnessDetails.medication28) ? illnessDetails.medication28 : ''),
  //     dose28: new FormControl((illnessDetails && illnessDetails.dose28) ? illnessDetails.dose28 : ''),
  //     frequency28: new FormControl((illnessDetails && illnessDetails.frequency28) ? illnessDetails.frequency28 : ''),
  //     prescribed28: new FormControl((illnessDetails && illnessDetails.prescribed28) ? illnessDetails.prescribed28 : ''),
  //     // illnessDetail: new FormControl((illnessDetails && illnessDetails.illness1) ? illnessDetails.illness : ''),
  //   })
  // }

  createWorkIllnessForm(workIllnessDetails) {
    this.workIllnessForm = this._formBuilder.group({
      selectAllNo: new FormControl((workIllnessDetails && workIllnessDetails.selectAllNo) ? workIllnessDetails.selectAllNo : false),
      workIllness1: new FormControl((workIllnessDetails && workIllnessDetails.workIllness1) ? workIllnessDetails.workIllness1 : '', Validators.required),
      workIllness2: new FormControl((workIllnessDetails && workIllnessDetails.workIllness2) ? workIllnessDetails.workIllness2 : '', Validators.required),
      workIllness3: new FormControl((workIllnessDetails && workIllnessDetails.workIllness3) ? workIllnessDetails.workIllness3 : '', Validators.required),
      workIllness4: new FormControl((workIllnessDetails && workIllnessDetails.workIllness4) ? workIllnessDetails.workIllness4 : '', Validators.required),
      workIllness5: new FormControl((workIllnessDetails && workIllnessDetails.workIllness5) ? workIllnessDetails.workIllness5 : '', Validators.required),
      workIllness6: new FormControl((workIllnessDetails && workIllnessDetails.workIllness6) ? workIllnessDetails.workIllness6 : '', Validators.required),
      workIllness7: new FormControl((workIllnessDetails && workIllnessDetails.workIllness7) ? workIllnessDetails.workIllness7 : '', Validators.required),
      workIllness8: new FormControl((workIllnessDetails && workIllnessDetails.workIllness8) ? workIllnessDetails.workIllness8 : '', Validators.required),
      workIllness9: new FormControl((workIllnessDetails && workIllnessDetails.workIllness9) ? workIllnessDetails.workIllness9 : '', Validators.required),
      workIllness10: new FormControl((workIllnessDetails && workIllnessDetails.workIllness10) ? workIllnessDetails.workIllness10 : '', Validators.required),
      workIllness11: new FormControl((workIllnessDetails && workIllnessDetails.workIllness11) ? workIllnessDetails.workIllness11 : '', Validators.required),
      workIllness12: new FormControl((workIllnessDetails && workIllnessDetails.workIllness12) ? workIllnessDetails.workIllness12 : '', Validators.required),
      workIllnessDetail: new FormControl((workIllnessDetails && workIllnessDetails.workIllnessDetail) ? workIllnessDetails.workIllnessDetail : ''),
    })
  }

  createOtherSafetyReqForm(otherSafetyReqDetails) {
    this.otherSafetyReqForm = this._formBuilder.group({
      selectAllNo: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.selectAllNo) ? otherSafetyReqDetails.selectAllNo : false),
      otherSafetyR1: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR1) ? otherSafetyReqDetails.otherSafetyR1 : '', Validators.required),
      otherSafetyR2: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR2) ? otherSafetyReqDetails.otherSafetyR2 : '', Validators.required),
      otherSafetyR3: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR3) ? otherSafetyReqDetails.otherSafetyR3 : '', Validators.required),
      otherSafetyR4: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR4) ? otherSafetyReqDetails.otherSafetyR4 : '', Validators.required),
      otherSafetyR5: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR5) ? otherSafetyReqDetails.otherSafetyR5 : '', Validators.required),
      otherSafetyR6: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR6) ? otherSafetyReqDetails.otherSafetyR6 : '', Validators.required),
      otherSafetyR7: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR7) ? otherSafetyReqDetails.otherSafetyR7 : '', Validators.required),
      otherSafetyR8: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR8) ? otherSafetyReqDetails.otherSafetyR8 : '', Validators.required),
      otherSafetyR9: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR9) ? otherSafetyReqDetails.otherSafetyR9 : '', Validators.required),
      otherSafetyR10: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR10) ? otherSafetyReqDetails.otherSafetyR10 : '', Validators.required),
      otherSafetyR11: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR11) ? otherSafetyReqDetails.otherSafetyR11 : '', Validators.required),
      otherSafetyR12: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR12) ? otherSafetyReqDetails.otherSafetyR12 : '', Validators.required),
      otherSafetyR13: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR13) ? otherSafetyReqDetails.otherSafetyR13 : '', Validators.required),
      otherSafetyR14: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyR14) ? otherSafetyReqDetails.otherSafetyR14 : '', Validators.required),
      otherSafetyYes: new FormControl((otherSafetyReqDetails && otherSafetyReqDetails.otherSafetyYes) ? otherSafetyReqDetails.otherSafetyYes : '')
    })
  }

  createOtherQuestionsForm(otherQuestionDetails) {
    this.otherQuestionsForm = this._formBuilder.group({
      selectAllNo: new FormControl((otherQuestionDetails && otherQuestionDetails.selectAllNo) ? otherQuestionDetails.selectAllNo : false),
      otherQ1: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ1) ? otherQuestionDetails.otherQ1 : '', Validators.required),
      otherQ2: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ2) ? otherQuestionDetails.otherQ2 : '', Validators.required),
      otherQ3: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ3) ? otherQuestionDetails.otherQ3 : '', Validators.required),
      otherQ4: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ4) ? otherQuestionDetails.otherQ4 : '', Validators.required),
      otherQ5: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ5) ? otherQuestionDetails.otherQ5 : '', Validators.required),
      otherQ6: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ6) ? otherQuestionDetails.otherQ6 : '', Validators.required),
      otherQ7: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ7) ? otherQuestionDetails.otherQ7 : '', Validators.required),
      otherQ8: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ8) ? otherQuestionDetails.otherQ8 : '', Validators.required),
      otherQ9: new FormControl((otherQuestionDetails && otherQuestionDetails.otherQ9) ? otherQuestionDetails.otherQ9 : '', Validators.required),
    })
  }


  createMedicationForm(medicationDetails?) {
    this.medicationForm = this._formBuilder.group({
      medicationList: this._formBuilder.array(this.multipleMedication((medicationDetails && medicationDetails.medicationList) ? medicationDetails.medicationList : []))
    })
  }


  // Get address list from formgroup
  get getMedicationList() { return this.medicationForm.get('medicationList') as FormArray; }


  multipleMedication(medication) {
    console.log("LIST OF PO NUMBER", medication)
    if (medication && medication.length) {
      let medicationdata = []
      _.forEach(medication, async (singleMedication) => {
        await medicationdata.push(new FormGroup({
          illness: new FormControl((singleMedication && singleMedication.illness) ? singleMedication.illness : ''),
          medication: new FormControl((singleMedication && singleMedication.medication) ? singleMedication.medication : '', !this._isComplete ? Validators.required : null),
          dose: new FormControl((singleMedication && singleMedication.dose) ? singleMedication.dose : ''),
          frequency: new FormControl((singleMedication && singleMedication.frequency) ? singleMedication.frequency : ''),
          prescribed: new FormControl((singleMedication && singleMedication.prescribed) ? singleMedication.prescribed : ''),
        }))
      })
      return medicationdata;
    } else {
      return [this._formBuilder.group({
        illness: new FormControl(''),
        medication: new FormControl('', !this._isComplete ? Validators.required : null),
        dose: new FormControl(''),
        frequency: new FormControl(''),
        prescribed: new FormControl('')
      })]
    }
  }


  addMultipleMedication() {
    const control = <FormArray>this.medicationForm.controls.medicationList
    control.push(this._formBuilder.group({
      illness: new FormControl(''),
      medication: new FormControl(''),
      dose: new FormControl(''),
      frequency: new FormControl(''),
      prescribed: new FormControl('')
    }))
  }

  deleteMedication(index) {
    const control = <FormArray>this.medicationForm.controls.medicationList
    control.removeAt(index)
  }


  createMedicalEyeStandardForm(medicalEyeStandardDetails) {
    this.medicalEyeStandardForm = this._formBuilder.group({
      medicalEye1: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEye1) ? medicalEyeStandardDetails.medicalEye1 : '', Validators.required),
      medicalEye2: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEye2) ? medicalEyeStandardDetails.medicalEye2 : '', Validators.required),
      medicalEye3: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEye3) ? medicalEyeStandardDetails.medicalEye3 : ''),
      medicalEyeSign: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeSign) ? medicalEyeStandardDetails.medicalEyeSign : '', Validators.required),
      medicalEyeName: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeName) ? medicalEyeStandardDetails.medicalEyeName : (this.userData && this.userData.fullName) ? this.userData.fullName : '', Validators.required),
      medicalEyeDate: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeDate) ? medicalEyeStandardDetails.medicalEyeDate : this.currentDate, Validators.required),
      medicalCircumstance: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalCircumstance) ? medicalEyeStandardDetails.medicalCircumstance : ''),
      medicalEyeSign2: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeSign2) ? medicalEyeStandardDetails.medicalEyeSign2 : ''),
      medicalEyeName2: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeName2) ? medicalEyeStandardDetails.medicalEyeName2 : (this.userData && this.userData.fullName) ? this.userData.fullName : ''),
      medicalEyeDate2: new FormControl((medicalEyeStandardDetails && medicalEyeStandardDetails.medicalEyeDate2) ? medicalEyeStandardDetails.medicalEyeDate2 : this.currentDate),
    })
  }

  createNightWorkerForm(nightWorkerDetails) {
    this.nightWorkerForm = this._formBuilder.group({
      nightWorkQ1: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ1) ? nightWorkerDetails.nightWorkQ1 : '', Validators.required),
      nightWorkQ2: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ2) ? nightWorkerDetails.nightWorkQ2 : '', Validators.required),
      nightWorkQ3: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ3) ? nightWorkerDetails.nightWorkQ3 : '', Validators.required),
      nightWorkQ4: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ4) ? nightWorkerDetails.nightWorkQ4 : '', Validators.required),
      nightWorkQ5: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ5) ? nightWorkerDetails.nightWorkQ5 : '', Validators.required),
      nightWorkQ6: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ6) ? nightWorkerDetails.nightWorkQ6 : '', Validators.required),
      nightWorkQ7: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ7) ? nightWorkerDetails.nightWorkQ7 : '', Validators.required),
      nightWorkQ8: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ8) ? nightWorkerDetails.nightWorkQ8 : '', Validators.required),
      nightWorkQ9: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ9) ? nightWorkerDetails.nightWorkQ9 : '', Validators.required),
      nightWorkQ10: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ10) ? nightWorkerDetails.nightWorkQ10 : '', Validators.required),
      nightWorkQ11: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ11) ? nightWorkerDetails.nightWorkQ11 : '', Validators.required),
      // nightWorkQ12: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ12) ? nightWorkerDetails.nightWorkQ12 : '', Validators.required),
      nightWorkQ13: new FormControl((nightWorkerDetails && nightWorkerDetails.nightWorkQ13) ? nightWorkerDetails.nightWorkQ13 : ''),
    })
  }

  createWorkingTimeForm(workingTimeDetails) {
    this.workingTimeForm = this._formBuilder.group({
      optOutQ1: new FormControl((workingTimeDetails && workingTimeDetails.optOutQ1) ? workingTimeDetails.optOutQ1 : '', Validators.required),
      optOutName: new FormControl((workingTimeDetails && workingTimeDetails.optOutName) ? workingTimeDetails.optOutName : (this.userData && this.userData.fullName) ? this.userData.fullName : '', Validators.required),
      optOutDate: new FormControl((workingTimeDetails && workingTimeDetails.optOutDate) ? workingTimeDetails.optOutDate : this.currentDate, Validators.required),
      optOutSign: new FormControl((workingTimeDetails && workingTimeDetails.optOutSign) ? workingTimeDetails.optOutSign : '', Validators.required)
    });
  }

  createWorkingHourDisclaimerForm(workingHourDisclaimerDetails) {
    this.workingHourDisclaimerForm = this._formBuilder.group({
      whdName: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdName) ? workingHourDisclaimerDetails.whdName : (this.userData && this.userData.fullName) ? this.userData.fullName : '', Validators.required),
      whdDate: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdDate) ? workingHourDisclaimerDetails.whdDate : this.currentDate, Validators.required),
      whdSign: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdSign) ? workingHourDisclaimerDetails.whdSign : '', Validators.required),
      // whdDate2: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdDate2) ? workingHourDisclaimerDetails.whdDate2 : this.currentDate, Validators.required),
      // whdSign2: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdSign2) ? workingHourDisclaimerDetails.whdSign2 : '', Validators.required),
      whdDate3: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdDate3) ? workingHourDisclaimerDetails.whdDate3 : this.currentDate, Validators.required),
      whdSign3: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdSign3) ? workingHourDisclaimerDetails.whdSign3 : '', Validators.required),
      whdDate4: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdDate4) ? workingHourDisclaimerDetails.whdDate4 : this.currentDate, Validators.required),
      whdSign4: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdSign4) ? workingHourDisclaimerDetails.whdSign4 : '', Validators.required),
    });
  }

  createSponserShipContractForm(contractDetails) {
    this.sponserShipContractForm = this._formBuilder.group({
      empStatus: new FormControl((contractDetails && contractDetails.empStatus) ? contractDetails.empStatus : '', Validators.required),
      sponsershipSign: new FormControl((contractDetails && contractDetails.sponsershipSign) ? contractDetails.sponsershipSign : '', Validators.required),
      sponsershipDate: new FormControl((contractDetails && contractDetails.sponsershipDate) ? contractDetails.sponsershipDate : this.currentDate, Validators.required),
      // sponsershipSign2: new FormControl((contractDetails && contractDetails.sponsershipSign2) ? contractDetails.sponsershipSign2 : ''),
      // sponsershipDate2: new FormControl((contractDetails && contractDetails.sponsershipDate2) ? contractDetails.sponsershipDate2 : ''),
    })
  }


  createReferencesForm(referencesDetails?) {
    this.referencesForm = this._formBuilder.group({
      name1: new FormControl((referencesDetails && referencesDetails.name1) ? referencesDetails.name1 : '', !this._isComplete ? Validators.required : null),
      company1: new FormControl((referencesDetails && referencesDetails.company1) ? referencesDetails.company1 : ''),
      durationFrom1: new FormControl((referencesDetails && referencesDetails.durationFrom1) ? referencesDetails.durationFrom1 : ''),
      durationTo1: new FormControl((referencesDetails && referencesDetails.durationTo1) ? referencesDetails.durationTo1 : ''),
      email1: new FormControl((referencesDetails && referencesDetails.email1) ? referencesDetails.email1 : ''),
      contact1: new FormControl((referencesDetails && referencesDetails.contact1) ? referencesDetails.contact1 : ''),
      name2: new FormControl((referencesDetails && referencesDetails.name2) ? referencesDetails.name2 : ''),
      company2: new FormControl((referencesDetails && referencesDetails.company2) ? referencesDetails.company2 : ''),
      durationFrom2: new FormControl((referencesDetails && referencesDetails.durationFrom2) ? referencesDetails.durationFrom2 : ''),
      durationTo2: new FormControl((referencesDetails && referencesDetails.durationTo2) ? referencesDetails.durationTo2 : ''),
      email2: new FormControl((referencesDetails && referencesDetails.email2) ? referencesDetails.email2 : ''),
      contact2: new FormControl((referencesDetails && referencesDetails.contact2) ? referencesDetails.contact2 : '')
    })
    console.log("CURRENT REFERENCE FORM DATA", this.referencesForm, this._isComplete)
  }


  createConfirmationForm(confirmationDetails?) {
    this.confirmationForm = this._formBuilder.group({
      date: new FormControl((confirmationDetails && confirmationDetails.date) ? confirmationDetails.date : this.currentDate, Validators.required),
      sign: new FormControl((confirmationDetails && confirmationDetails.sign) ? confirmationDetails.sign : '', Validators.required)
    })
  }

  // UTILITY


  finalStepp(stepper: MatStepper) {
    // console.log("EVENT", event)
    console.log("DATA OF", this._isFinalStep)
    stepper.next()
    stepper.selectedIndex = 18
    this._isFinalStep = true
    // this._isFinalStep = !this._isFinalStep
    this._isComplete = true
    console.log("AFTER DATA OF", this._isFinalStep)
    this._cd.detectChanges()
    console.log("LAST STEPPER VALUE", stepper, stepper.selectedIndex)
    // this.workingHourDisclaimerForm.get('whdDate2').setValidators([Validators.required])
    // this.workingHourDisclaimerForm.get('whdSign2').setValidators([Validators.required])
    // this.workIllnessForm.get('workIllnessDetail').setValidators([Validators.required]);
  }

  addProfileImage(event: any) {
    console.log("event", event);

    // this.profileFile = event.target.files;
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        // console.log("what is event", event.target.files[0]);
        this.url1 = event.target.result;
      }
      // this.profileFile.emit(event.target.files[0])
      reader.readAsDataURL(event.target.files[0]);
      this.profilePhoto = event.target.files[0]
      // this.sectionOneForm.get('profilePhoto').patchValue(event.target.files[0])
      console.log("after response of url", this.sectionOneForm.value);
    }
  }

  onSelectionChange(event) {
    console.log("event", event)
    if (event) this.isTopToApp.emit({ isTop: true })
  }

  onChange(event, fomrControl, formGroup) {
    console.log("DATE SELECT EVENT", event)
    formGroup.get(fomrControl).patchValue(event)
    console.log("AFTER DATE VALUE ASSIGNED", formGroup.value)
  }

  _keyPress(event: any) {
    console.log("event is call or not", event);
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }


  workIllnessRadioChanges(event) {
    let newObj = this.workIllnessForm.value
    let check = Object.keys(newObj).find(key => newObj[key] === 'Yes')
    console.log("WHAT IS THE CHECK0, c0", check)
    if (check !== undefined) {
      this.showWorkIllnessDetail = true
      this.workIllnessForm.get('workIllnessDetail').setValidators([Validators.required]);
      this._cd.detectChanges()
    } else {
      this.showWorkIllnessDetail = false
      this.workIllnessForm.get('workIllnessDetail').setValidators(null);
      this.workIllnessForm.controls['workIllnessDetail'].reset();
      this._cd.detectChanges()
    }
  }




  selectAllNo(event, formGroupName, formGroupType) {
    console.log("WHAT IS IN THE EVENT", event, formGroupName)
    if (event.checked === true) {
      for (let key in formGroupName.controls) {
        if (formGroupType === 'illnessForm') {
          this.getIllnessesList.controls.forEach((group, index) => {
            group.get('illness' + (index + 1)).setValue('No');
          });

          // if (key.includes('illness')) formGroupName.controls[key].patchValue('No')
        } else {
          if (key !== 'selectAllNo' && key !== 'otherSafetyYes') {
            formGroupName.controls[key].patchValue('No')
          }
          if (formGroupType === 'workIllnessForm') {
            this.showWorkIllnessDetail = false
            formGroupName.controls['workIllnessDetail'].reset()
          }
        }
      }
      console.log("MARK FORM GROUP VALUE", formGroupName.value)
    }
    else {

      if (formGroupType === 'illnessForm') {
        this.getIllnessesList.controls.forEach((group, index) => {
          group.get('illness' + (index + 1)).setValue('');
        });
      } else {
        formGroupName.reset();
        this._cd.detectChanges()
      }
      if (formGroupType === 'workIllnessForm') {
        this.showWorkIllnessDetail = false
        formGroupName.controls['workIllnessDetail'].reset()
      }
      console.log("AFTER RESET THE FORM GROUP VALUE", formGroupName.value)
    }
  }

  addSignature(formControl, formGroup) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent, 'user')
      .afterClosed().subscribe((data) => {
        if (data == undefined) return
        else {
          formGroup.get(formControl).patchValue(data)
          console.log("AFTER SIGNATURE ASSIGNED", formGroup.value)
        }
      })
  }

  closeForm() {
    console.log("CURRENT STEPPER DATA", this.stepper)
    this.stepper.reset()
    this._isComplete = false
    this._isFinalStep = false
    this.createForm()
    this.url1 = null
    this.formClose.emit('closed')
  }

  approveOrRejectUser(action) {
    this.userAction.emit(action)
  }


  validateForm(stepper: MatStepper, formGroup, formGroupName?) {
    console.log("CURRENT FORM VALIDATION CHECKS", stepper.selectedIndex)
    if (formGroup.valid) {
      stepper.next()
    } else {
      formGroup.markAllAsTouched()
      this._cd.detectChanges()
    }

    if (formGroupName === 'personlDetailsForm') {
      this.userData = formGroup.value
      this.medicalEyeStandardForm.get('medicalEyeName').patchValue(this.userData.fullName)
      this.medicalEyeStandardForm.get('medicalEyeName2').patchValue(this.userData.fullName)
      this.railPPEForm.get('ppeName').patchValue(this.userData.fullName)
      this.workingTimeForm.get('optOutName').patchValue(this.userData.fullName)
      this.workingHourDisclaimerForm.get('whdName').patchValue(this.userData.fullName)
    }
    if (formGroupName === 'otherQuestionsForm') {
      // console.log("STEPPER 6 FORM DATA", this.illnessForm.value)
      // console.log("STEPPER 10 form value", this.medicationForm.value)
      const control = <FormArray>this.medicationForm.controls.medicationList
      while (control.length !== 0) control.clear()
      this.getIllnessesList.controls.forEach((group, index) => {
        // console.log("WHAT IS THE GET", group, group.get('illness' + (index + 1)), group.get('illness' + (index + 1)).value)
        // group.get('illness' + (index + 1)).setValue('');
        if (group.get('illness' + (index + 1)).value === 'Yes') {
          control.push(this._formBuilder.group({
            illness: new FormControl({ value: group.get('label' + (index + 1)).value, disabled: true }),
            medication: new FormControl(group.get('medication' + (index + 1)).value),
            dose: new FormControl(group.get('dose' + (index + 1)).value),
            frequency: new FormControl(group.get('frequency' + (index + 1)).value),
            prescribed: new FormControl(group.get('prescribed' + (index + 1)).value)
          }))
        }
      });
      if (control.value && !control.value.length) {
        control.push(this._formBuilder.group({
          illness: new FormControl(''),
          medication: new FormControl(''),
          dose: new FormControl(''),
          frequency: new FormControl(''),
          prescribed: new FormControl('')
        }))
      }
      console.log("AFTER UPDATE THE FORMGROUP VALUE", control.value)
    }

    if (formGroupName === 'railPPEForm') {
      this.referencesForm.get('name1').setValidators(null);
      this.referencesForm.get('name1').reset();
    }

  }

  medicalQuestion(event, formControl) {
    console.log("EVENT OF CHECK", event)
    console.log("FORM CONTROL", formControl)
    if (event.value && event.value === 'Yes') {
      this.medicalEyeStandardForm.get('medicalEye3').setValidators([Validators.required]);
    } else {
      this.medicalEyeStandardForm.get('medicalEye3').setValidators(null);
      this.medicalEyeStandardForm.get('medicalEye3').reset();
    }
    // const controlValue = this.medicalEyeStandardForm.get('')
  }


  setCurrentLocation(mapCurrentValue) {
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.personlDetailsForm.patchValue({
      coordinates: [this.longitude, this.latitude],
      userAddress: this.address,
    })
    this.getAddressList().clear()
    this.updateAddressData(splitAddress)
    this.getWhat3words(this.latitude, this.longitude)

  }


  // Update the address details in array formate
  updateAddressData(address) {
    const control = this.getAddressList()
    address.forEach(element => {
      control.push(
        this._formBuilder.group({ title: { value: element, disabled: true } })
      )
    });
  }

  // Change location using drag and drop and update location
  changeLocation(location, inputIndex) {
    let element = []
    element.push(this.getAddressList().value.map((x) => { return x.title }))
    const address = this.getAddressList().value
    let singleAddress = address.map((x) => { return x.title }).join(',')
  }

  // Generate What3words for selected location
  getWhat3words(latitude, longitude) {
    what3words.api.convertTo3waGeoJson({ lat: latitude, lng: longitude }, 'en').then((words) => {
      this.what3words = { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words }
      // this._cd.detectChanges()
      this.personlDetailsForm.patchValue({ what3words: { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words } })
    })
    // console.log("EDIT USER FORM DATA", this.editUserForm.value)
  }


  addFileModal() {
    let obj = {
      isSponsor: true,
    }

    // if (this.materialId != undefined) {
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent, obj).afterClosed().subscribe((fileQueue) => {
      console.log("FILE QUE", fileQueue)
      if (fileQueue === undefined) return
      else {
        if (fileQueue && fileQueue.length) {
          this.fileList = fileQueue
          this.workEligibilityForm.get('documents').patchValue(this.fileList)
          // console.log("THIS IS THE FILE LIST", this.fileList)
        }
      }

    })
  }


  removeDocument(file) {
    console.log("REMOVE DOUCMENT DATA", file)
    let fileIndex = this.fileList.findIndex((x) => x.key === file.key)
    console.log("THIS IS THE FILE INDEX", fileIndex)
    if (fileIndex !== -1) {
      this.fileList.splice(fileIndex, 1)
      console.log("AFTER REMOVE FILE", this.fileList)
      this.workEligibilityForm.get('documents').patchValue(this.fileList)
    }

  }

  selectNotApplicable(event) {
    console.log("WHAT IS THE EVENT", event)
    if (event && event.checked) {
      this.workEligibilityForm.controls['que3'].disable()
      this.workEligibilityForm.controls['queComment'].disable()
      this.workEligibilityForm.controls['que4'].disable()
      this.workEligibilityForm.controls['que5'].disable()
    } else {
      this.workEligibilityForm.controls['que3'].enable()
      this.workEligibilityForm.controls['queComment'].enable()
      this.workEligibilityForm.controls['que4'].enable()
      this.workEligibilityForm.controls['que5'].enable()
    }
  }

  // API CALL

  // Submit Sponsor Pack Form

  submitForm() {
    // console.log("FORM SUBMISSION EVENT", event)
    if (this.confirmationForm.valid) {

      this.loading = true
      console.log("CONFIRMATOIN FORM", this.confirmationForm.value)
      let obj = {
        type: 'subsponsorship'
      }
      let details = {
        sectionOneDetails: this.sectionOneForm.value,
        workEligibilityDetails: this.workEligibilityForm.value,
        opportunitiesDetails: this.opportunitiesForm.value,
        personlDetails: this.personlDetailsForm.getRawValue(),
        kinDetails: this.kinDetailsForms.value,
        illness: this.illnessForm.value,
        workIllness: this.workIllnessForm.value,
        otherSafetyReq: this.otherSafetyReqForm.value,
        otherQuestions: this.otherQuestionsForm.value,
        medicationDetails: this.medicationForm.getRawValue(),
        medicalEyeStandard: this.medicalEyeStandardForm.value,
        nightWorker: this.nightWorkerForm.value,
        workingTime: this.workingTimeForm.value,
        workingHourDisclaimer: this.workingHourDisclaimerForm.value,
        sponserShipContract: this.sponserShipContractForm.value,
        railPPEDetails: this.railPPEForm.value,
        referencesDetails: this.referencesForm.value,
        confirmationDetails: this.confirmationForm.value
      }
      obj['details'] = details
      // const data = new FormData();
      // data.append('profile' , this.profilePhoto)
      // console.log("THIS IS THE DETAILS", obj)
      this._userDocumentService.submitSponsorPackForm(obj, this.profilePhoto).subscribe((submitted) => {
        console.log("SPONSOR PACK SUBMITTED", submitted)
        this.loading = false
        this.showMessage = true
        setTimeout(() => {
          window.location.reload()
        }, 3000);
      }, error => {
        console.log("ERROR IN SUBMITTING FORM", error)
        this._utilityService.openSnackBar(error.msg, "OK")
        this.showMessage = false
        this.loading = false
      })
    }
    else {
      this.confirmationForm.markAllAsTouched()
      this._cd.detectChanges()
    }
  }

}
